import 'es6-promise/auto';

// UI
import 'reset-css/reset.css';
import jQuery from 'jquery';
import 'bootstrap-grid/dist/grid.min.css';

import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale'
locale.use(lang)

// Main Application
import Vue from 'vue';
import draggable from 'vuedraggable';

Vue.prototype.$isTouch = ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch)

// Setup Element.IO components
import { Alert, Badge, Button, Card, Checkbox, Collapse, CollapseItem, DatePicker, Dialog, Input, Loading, Message, MessageBox, Notification, Option, Select, Slider, Switch, Tag, Tabs, TabPane, Tooltip, Popover, Radio, RadioButton, RadioGroup} from 'element-ui'

Vue.use(Alert)
Vue.use(Badge)
Vue.use(Button)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Loading.directive)
Vue.use(Option)
Vue.use(Select)
Vue.use(Slider)
Vue.use(Switch)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tag)
Vue.use(Tooltip)
Vue.use(Popover)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)

Vue.prototype.$loading  = Loading.service
Vue.prototype.$msgbox   = MessageBox
Vue.prototype.$alert    = MessageBox.alert
Vue.prototype.$confirm  = MessageBox.confirm
Vue.prototype.$prompt   = MessageBox.prompt
Vue.prototype.$notify   = Notification
Vue.prototype.$message  = Message

import VueVisible from 'vue-visible';
Vue.use(VueVisible);

import scrollTo from 'vue-scrollto';
Vue.use(scrollTo)
Vue.prototype.$scrollTo = scrollTo

// Requests/Authentication
import Axios from 'axios';
import CreateError from 'axios/lib/core/createError'
import AxiosCancel from 'axios-cancel';
AxiosCancel(Axios, Vue, {
  debug: false
});

// Routing & Storage
import VueRouter from 'vue-router';
import routes from './routes';
import { sync } from 'vuex-router-sync';
import store from './store';

// setup domain to match proxy to overcome cross-origin with iframe
document.domain = (() => {
  let domainParts = document.domain.split('.')
  let l = domainParts.length
  return l >= 2? domainParts[l - 2] + '.' + domainParts[l - 1]: document.domain
})()

// Setup Vue config
Vue.config.debug = Vue.config.performance = process.env.NODE_ENV !== 'production';
Vue.use(VueRouter);

// Clear login errors
store.commit('loginError', null);

// Override all ajax requests, log the user out if we detect that they're not authed
Axios.defaults.baseURL                      = process.env.API_LOCATION;
Axios.defaults.headers.common.Accept        = 'application/json';
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Axios.isApiError = (error) => {
  return !!(
    !Axios.isCancel(error) && (
      !error.response ||
      (error && error.response && error.response.data && error.response.data._meta && !error.response.data._meta.success)
    )
  )
}

Axios.interceptors.request.use(
  config => {
    if (store.state.user.session_id && store.state.user.session_id.length > 0) {
      config.headers              = config.headers || {};
      config.headers['api-token'] = store.state.user.session_id;
    }

    return config;
  },
  error => error
);

Axios.interceptors.response.use(
  response => {
    if (!response || !response.data || !response.data._meta || !response.data._meta.success)
      return Promise.reject(CreateError('API Error', response.config, response.code, response.request, response))
    
    if (response && response.data && response.data._meta && response.data._meta.impersonation)
      store.dispatch('affiliate', { id: response.data._meta.impersonation, company: null })
    
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      store.commit('loginError', 'Session expired, please login again')
      store.dispatch('logout')
    }

    return Promise.reject(error)
  });
Vue.$http = Vue.prototype.$http = Axios;

const router = Vue.router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes,
});

// Auth validation before routing
router.beforeEach((to, from, next) => {
  const hash    = window.location.hash && window.location.hash.substr(2)
  const noPath  = ['', '/'].indexOf(window.location.pathname || '') !== -1
  window.location.hash = ''

  // Hashbang is set
  if (hash && hash != '' && noPath) {
    next({ path: hash })

  // User is accessing a page that requires being logged in, but is not
  } else if (to.matched.some(m => m.meta.auth) && !store.state.user.session_id) {
    next({ name: 'login' });

  // User is accessing a page that requires being an employee and also in impersonation, but is not
  } else if (to.matched.some(m => m.meta.impersonation) && !store.getters.isImpersonated) {
    Notification.error({
      title: 'Error',
      message: 'You must impersonate an Affiliate first',
      position: 'bottom-right'
    })
    next({ name: 'performance' });

  // If user is on a guest page move them to an authed page
  } else if (to.matched.some(m => m.meta.guest) && store.state.user.session_id) {
    next({ name: 'performance' });

  // Normal operation
  } else {
    next();
  }
});

sync(store, router);

/* Custom filters */
Vue.filter('reverse', function (array) {
  return array.slice().reverse();
});

Vue.filter('displayIndex', function(index) {
  return (index + 1).toString();
});

import App from './index';
const app = new Vue(Vue.util.extend({
  router,
  store,
}, App));

export { app, router, store };

window.$ = jQuery;
app.$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js